import { render } from "./NoStockProductsPage.vue?vue&type=template&id=53556224"
import script from "./NoStockProductsPage.vue?vue&type=script&lang=js"
export * from "./NoStockProductsPage.vue?vue&type=script&lang=js"

import "@/css/OutstockPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__